/**
 * Header Container Component
 */
import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';

/* Import Header Styles */
import './header.scss';

/* Import View Components */
import { MyDillardsBar } from '../../../Views/Desktop/Header/MyDillardsBar/MyDillardsBar';
import Search from '../../../Views/Desktop/Header/Search/Search';
import { Navigation } from '../../../Views/Desktop/Header/Navigation/Navigation';

/* Import UI Components */
import { SetInnerHTML } from '../../../UI/SetInnerHTML/SetInnerHTML';

/*Api Request*/
import TippyTop from '../../../Views/Desktop/Header/TippyTop/TippyTop';
import ShoppingBagIcon from './Icons/shoppingBagIcon.svg';
import ArrowDownIcon from './Icons/arrowDownIcon.svg';
import UserLoginIcon from './Icons/userLoginIcon.svg';
import PlayIcon from './Icons/playIcon.svg';
import PauseIcon from './Icons/pauseIcon.svg';
import { savePersonalizationPointsToDatabase } from '../../../../util/personalization';

export class HeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      megaMenuState: {},
      headerClicked: null,
      menuOpen: false,
      previousCatClicked: null,
      getSelectedMenuState: '',
      slideIndex: 0,
      updateCount: 0,
      isPlaying: true,
      isMegaMenuListener: false,
    };

    this.NavMegaMenuData = this.NavMegaMenuData.bind(this);
    this.handleNavMegaMenuData = this.handleNavMegaMenuData.bind(this);
    this.closeTabletMenu = this.closeTabletMenu.bind(this);
    this.handleSelectedMenuState = this.handleSelectedMenuState.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.checkIt = this.checkIt.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handlePromoPausePlay = this.handlePromoPausePlay.bind(this);
    this.state.storedMyDillardsInfo = JSON.parse(JSON.stringify(this.props.myDillardsInfo));
    this.state.storedIsInternational = this.props.passedAppFunctions.isInternational();
    this.state.storedCountry = this.props.passedAppFunctions.country;
    this.state.storedCurrency = this.props.passedAppFunctions.currency;
    this.forceHeaderRender = this.forceHeaderRender.bind(this);
    this.scrollToContent = this.scrollToContent.bind(this);
    this.handleMenuScroll = this.handleMenuScroll.bind(this);
    this.animationObserver = this.animationObserver.bind(this);
    this.handleAnimationRotation = this.handleAnimationRotation.bind(this);
    this.megaMenuKeyboardNav = this.megaMenuKeyboardNav.bind(this);
    this.focusMegaMenu = this.focusMegaMenu.bind(this);
  }
  forceHeaderRender() {
    this.setState({ force: true });
  }
  componentDidMount() {
    window.forceHeaderRender = this.forceHeaderRender;
    window.addEventListener('scroll', this.handleMenuScroll);
    this.animationObserver();
    if (
      this.props.siteFormat == 'tablet' &&
      this.props.headerData.JSON.ES_Header_Promo_JSON != undefined &&
      this.props.headerData.JSON.ES_Header_Promo_JSON.length > 0
    ) {
      window.addEventListener('orientationchange', this.handleAnimationRotation);
    }
  }
  componentWillUnmount() {
    var megaMenu = document.querySelector('.mega-menu-wrapper');
    window.removeEventListener('scroll', this.handleMenuScroll);
    window.removeEventListener('orientationchange', this.handleAnimationRotation);
    if (megaMenu != null) {
      megaMenu.removeEventListener('keydown', this.megaMenuKeyboardNav);
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    var returnValue = false;
    if (!_.isEqual(nextProps.myDillardsInfo, this.state.storedMyDillardsInfo)) {
      this.state.storedMyDillardsInfo = JSON.parse(JSON.stringify(this.props.myDillardsInfo));
      returnValue = true;
    }
    if (this.props.passedAppFunctions.isInternational() != this.state.storedIsInternational) {
      this.state.storedIsInternational = this.props.passedAppFunctions.isInternational();
      returnValue = true;
    }
    if (
      this.props.passedAppFunctions.country != this.state.storedCountry ||
      this.props.passedAppFunctions.currency != this.state.storedCurrency
    ) {
      this.state.storedCountry = this.props.passedAppFunctions.country;
      this.state.storedCurrency = this.props.passedAppFunctions.currency;
      returnValue = true;
    }
    if (!_.isEqual(this.state, nextState)) {
      returnValue = true;
    }
    return returnValue;
  }

  componentDidUpdate() {
    if (
      this.state.megaMenuState.superCats != undefined &&
      this.props.passedAppFunctions.siteFormat == 'desktop' &&
      this.state.menuOpen == true &&
      document.querySelector('.hiddenSelected') != null
    ) {
      this.focusMegaMenu();
    }
    if (this.props.passedAppFunctions.siteFormat == 'tablet' && this.state.menuOpen == true) {
      var tabletMenuBackdrop = document.querySelector('.TabletMenu__backdrop');
      if (tabletMenuBackdrop) {
        tabletMenuBackdrop.style.top = tabletMenuBackdrop.previousElementSibling.offsetTop + 45 + 'px';
      }
    }
  }

  handleMenuScroll() {
    this.setState({
      menuOpen: false,
      previousCatClicked: null,
    });
  }

  NavMegaMenuData() {
    fetch('/wcs/resources/dropdown/desktop', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'omit',
    })
      .then((response) => {
        if (!response.ok) {
          // Handle HTTP errors
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((response) => {
        var returnData = response.response;
        try {
          if (typeof returnData == 'string') {
            returnData = returnData.replace(/[\u0000-\u001f]/g, '');
            returnData = JSON.parse(returnData);
          }
          this.setState({ megaMenuState: returnData });
        } catch (e) {
          console.log(e);
        }
      })
      .catch((err) => {
        throw err;
      });
  }

  handleNavMegaMenuData(evt) {
    setTimeout(() => {
      this.NavMegaMenuData();
    }, 500);
  }

  closeTabletMenu(event) {
    this.setState({
      menuOpen: false,
      previousCatClicked: null,
    });
  }
  closeMenu() {
    this.setState({
      menuOpen: false,
      previousCatClicked: null,
    });
  }

  onMouseOver() {
    this.props.passedAppFunctions.siteFormat == 'desktop' ? this.setState({ menuOpen: true }) : '';
  }
  onMouseOut() {
    this.props.passedAppFunctions.siteFormat == 'desktop' ? this.setState({ menuOpen: false }) : '';
  }

  // www 16607 ADA keyboard navigation
  toggleMenu(event) {
    var changed = false;
    var target = event.target.dataset.supername;
    var hiddenButtonForNav = document.querySelectorAll('.hiddenButtonForNav');

    for (var i = 0; i < hiddenButtonForNav.length; i++) {
      hiddenButtonForNav[i].classList.remove('hiddenSelected');
      hiddenButtonForNav[i].setAttribute('aria-expanded', 'false');
    }
    if (target != false && this.state.megaMenuState.superCats) {
      this.state.megaMenuState.superCats.forEach((supercat) => {
        if (supercat.display == target && supercat.display != this.state.getSelectedMenuState?.display) {
          this.setState({
            getSelectedMenuState: supercat,
          });
        }
      });
      changed = true;
    }
    if (!changed || !this.state.menuOpen) {
      this.props.passedAppFunctions.siteFormat == 'desktop' ? this.setState({ menuOpen: !this.state.menuOpen }) : '';
    }
    event.target.classList.add('hiddenSelected');
    event.target.ariaExpanded = 'true';
  }

  focusMegaMenu() {
    var menuCloseButton = document.querySelector('.megaMenuClose');
    var megaMenu = document.querySelector('.mega-menu-wrapper');

    if (this.state.isMegaMenuListener == false) {
      megaMenu.addEventListener('keydown', this.megaMenuKeyboardNav);
      this.setState({ isMegaMenuListener: true });
    }
    menuCloseButton.style.visibility = 'visible';
    menuCloseButton.focus();
  }

  megaMenuKeyboardNav(e) {
    var focusableElements = document.querySelectorAll('.mega-menu-wrapper-open a');
    var lastFocusable = focusableElements[focusableElements.length - 1];
    var currentHiddenNav = document.querySelector('.hiddenSelected');
    var menuCloseButton = document.querySelector('.megaMenuClose');

    if (e.key === 'Enter' && document.activeElement == menuCloseButton) {
      currentHiddenNav.focus();
      currentHiddenNav.classList.remove('hiddenSelected');
      currentHiddenNav.setAttribute('aria-expanded', 'false');
      menuCloseButton.style.visibility = 'hidden';
      this.setState({ menuOpen: false });
      e.preventDefault();
    }
    if (e.key === 'Escape') {
      currentHiddenNav.focus();
      currentHiddenNav.classList.remove('hiddenSelected');
      currentHiddenNav.setAttribute('aria-expanded', 'false');
      menuCloseButton.style.visibility = 'hidden';
      this.setState({ menuOpen: false });
    }
    if (e.shiftKey && e.keyCode == 9 && document.activeElement == menuCloseButton) {
      currentHiddenNav.focus();
      currentHiddenNav.classList.remove('hiddenSelected');
      currentHiddenNav.setAttribute('aria-expanded', 'false');
      menuCloseButton.style.visibility = 'hidden';
      this.setState({ menuOpen: false });
      e.preventDefault();
    }
    if (e.key === 'Tab' && document.activeElement == lastFocusable) {
      menuCloseButton.focus();
      e.preventDefault();
    }
  }
  // www 16607 ADA keyboard navigation

  handleSelectedMenuState(event) {
    var target = event.target.dataset.supername;
    var hiddenButtonForNav = document.querySelectorAll('.hiddenButtonForNav');
    var menuCloseButton = document.querySelector('.megaMenuClose');
    for (var i = 0; i < hiddenButtonForNav.length; i++) {
      hiddenButtonForNav[i].classList.remove('hiddenSelected');
      hiddenButtonForNav[i].setAttribute('aria-expanded', 'false');
    }
    if (menuCloseButton != null) {
      menuCloseButton.style.visibility = 'hidden';
    }
    if (target != false && this.state.megaMenuState.superCats) {
      this.state.megaMenuState.superCats.forEach((supercat) => {
        if (supercat.display == target) {
          this.setState({
            getSelectedMenuState: supercat,
          });
        }
      });
    }
  }

  handleKeyPress(event) {
    if (event.key == 'Enter') {
      event.preventDefault();
      this.handleSelectedMenuState(event);
      this.onMouseOver;
    } else this.onMouseOut;
  }
  checkIt(event) {
    var target = event.target.dataset.supername;
    const isEmpty =
      this.state.megaMenuState.superCats.find((supercat) => supercat.display == target)?.columns.length === 0;
    if (isEmpty) return;
    if (this.props.passedAppFunctions.siteFormat == 'tablet') {
      this.setState({ previousCatClicked: target });
      $(event.target).removeClass('noHover');
      if (target == this.state.previousCatClicked) {
        //CLOSE MENU AFTER DOUBLE CLICK
        this.closeTabletMenu();
        this.setState({ previousCatClicked: null });
        $(event.target).addClass('noHover');
      } else {
        event.preventDefault(event);
        $(event.target).addClass('topCatHover');
        $('.mega-menu-wrapper').attr('data-menucat', `${event.target.text}`);
        this.setState({ menuOpen: true });
      }
    }
    //11673 Supercategory Dropdown showing background cursor
    $('input').trigger('blur');
  }

  scrollToContent() {
    if (this.props.passedAppFunctions.siteFormat == 'desktop') {
      $('html, body').animate({ scrollTop: $('#content-wrapper, #content_wrapper').offset().top - 70 }, 50);
    }
  }

  animationObserver() {
    if (this.props.headerData.JSON.ES_Header_Promo_JSON != undefined) {
      var rootElement = document.getElementById('headerPromo');
      if (window.IntersectionObserver) {
        if (animationObserver) {
          animationObserver.disconnect();
        }
        var options = {
          root: rootElement,
          rootMargin: '0px',
          threshold: 0.5,
        };

        var animationObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.ariaHidden = 'false';
              entry.target.firstElementChild.firstElementChild.setAttribute('tabindex', '0');
            } else {
              entry.target.ariaHidden = 'true';
              entry.target.firstElementChild.firstElementChild.setAttribute('tabindex', '-1');
            }
          });
        }, options);

        document.querySelectorAll('#animatedPromo .promoWrapper').forEach((promoSlide) => {
          animationObserver.observe(promoSlide);
        });
      }
    }
  }

  // fix for iOS tablet edge cases - animation skipping on rotation
  handleAnimationRotation() {
    var animatedPromo = document.getElementById('animatedPromo');
    animatedPromo.setAttribute('style', 'animation-play-state: paused!important');
    setTimeout(function () {
      animatedPromo.removeAttribute('style');
    }, 2000);
  }

  handlePromoPausePlay() {
    var animatedPromo = document.getElementById('animatedPromo');
    if (this.state.isPlaying) {
      this.setState({ isPlaying: false });
      animatedPromo.style.animationPlayState = 'paused';
    } else {
      this.setState({ isPlaying: true });
      animatedPromo.style.animationPlayState = 'running';
    }
  }

  render() {
    var promoCount;
    if (this.props.headerData.JSON.ES_Header_Promo_JSON != undefined) {
      promoCount = this.props.headerData.JSON.ES_Header_Promo_JSON.length;
    }

    var headerPromos = [];
    if (
      this.props.headerData.JSON.ES_Header_Promo_JSON &&
      Array.isArray(this.props.headerData.JSON.ES_Header_Promo_JSON)
    ) {
      headerPromos = this.props.headerData.JSON.ES_Header_Promo_JSON;
    }

    if (typeof window != 'undefined' && window.injectHeaderPromos) {
      try {
        headerPromos = window.injectHeaderPromos(headerPromos);
      } catch (e) {
        console.log(e);
      }
    }

    var siteFormat = this.props.passedAppFunctions.siteFormat;

    return (
      <React.Fragment>
        <TippyTop closeMenu={this.closeMenu} />
        <header id='preScrollWrapper' className='p-0'>
          {this.props.headerData.JSON.ES_Tippy_Top_HTML !== undefined &&
          this.props.headerData.JSON.ES_Tippy_Top_HTML != '&nbsp;' ? (
            <div className='header_promo_static_wrapper' role='region' aria-label='Promotional Static'>
              <div className='promoStaticWrapper' aria-hidden='false'>
                <div className='promoStaticHeading'>
                  <SetInnerHTML
                    innerHTML={this.props.headerData.JSON.ES_Tippy_Top_HTML}
                    espotname='ES_Tippy_Top_HTML'
                  />
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          <div id='headerPromo' className='header_promo container-fluid' tabIndex='-1'>
            {siteFormat == 'desktop' ? (
              <a
                id='skipNavLink'
                className='skipNavigation'
                href='#content-wrapper'
                title='Skip to main content'
                onClick={this.scrollToContent}
              >
                Skip to main content
              </a>
            ) : (
              ''
            )}

            <div
              className='header_promo_wrapper'
              onTouchEnd={this.closeMenu}
              role='region'
              aria-label='Promotional Carousel'
            >
              <div id='animatedPromo' className={`promoCount-${promoCount}`}>
                {headerPromos.map((attr, index) => (
                  <React.Fragment key={index}>
                    <SetInnerHTML
                      className='promoWrapper'
                      innerHTML={index > 0 ? attr.split('tabindex').join('asdindex') : attr}
                    />
                  </React.Fragment>
                ))}
              </div>
              {siteFormat == 'desktop' ? (
                <button className='button' aria-labelledby='pauseButton' onClick={this.handlePromoPausePlay}>
                  {this.state.isPlaying ? (
                    <>
                      <PauseIcon />
                      <span>Pause</span>
                    </>
                  ) : (
                    <>
                      <PlayIcon />
                      <span>Play</span>
                    </>
                  )}
                </button>
              ) : (
                ''
              )}
            </div>
          </div>

          <MyDillardsBar
            activeTab={this.state.activeTab}
            myDillardsInfo={this.props.myDillardsInfo}
            domainName={this.props.passedAppFunctions.wasParms.domainName}
            passedAppFunctions={this.props.passedAppFunctions}
            siteFormat={this.props.siteFormat}
            headerData={this.props.headerData}
            closeMenu={this.closeMenu}
          />

          <section id='header_desktop_wrapper' className='header_desktop_wrapper_promo' onTouchEnd={this.closeMenu}>
            <div className={`${siteFormat == 'tablet' ? 'container' : 'container-fluid'}`}>
              <div
                id='header'
                onClick={this.closeTabletMenu}
                className={`${siteFormat == 'tablet' ? 'row mx-0 justify-content-between' : 'row mx-0'}`}
              >
                <div className={`${siteFormat == 'tablet' ? 'hide-on-tablet d-md-none' : 'col-5'}`}></div>
                <div className={`col-2 align-self-center justify-content-center main-logo`}>
                  <SetInnerHTML innerHTML={this.props.headerData.JSON.ES_Logo} espotname='ES_Logo' />
                </div>

                <div
                  className={`${siteFormat == 'desktop' ? 'col-5 pr-0 align-self-center' : 'col-8 pr-0 align-self-center'}`}
                >
                  <div className='row mx-0 flex-nowrap justify-content-end align-items-center'>
                    <div className={`${siteFormat == 'desktop' ? 'col-6 pl-0' : 'col-8'}`}>
                      <Search passedAppFunctions={this.props.passedAppFunctions} />
                    </div>
                    <LoginDropdown
                      passedAppFunctions={this.props.passedAppFunctions}
                      myDillardsInfo={this.props.myDillardsInfo}
                    />
                    <ShoppingBag
                      passedAppFunctions={this.props.passedAppFunctions}
                      myDillardsInfo={this.props.myDillardsInfo}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </header>
        <Navigation
          passedAppFunctions={this.props.passedAppFunctions}
          NavMegaMenuData={this.NavMegaMenuData}
          megaMenuState={this.state.megaMenuState}
          handleNavMegaMenuData={this.handleNavMegaMenuData}
          checkIt={this.checkIt}
          menuOpen={this.state.menuOpen}
          onMouseOut={this.onMouseOut}
          toggleMenu={this.toggleMenu}
          onMouseOver={this.onMouseOver}
          getSelectedMenuState={this.state.getSelectedMenuState}
          handleSelectedMenuState={this.handleSelectedMenuState}
          closeTabletMenu={this.closeTabletMenu}
          closeMenu={this.closeMenu}
        />
      </React.Fragment>
    );
  }
}

function preventDoubleClick() {
  if (document.getElementsByClassName('shopping-bag-count-container')[0]) {
    document.getElementsByClassName('shopping-bag-count-container')[0].style.pointerEvents = 'none';
  }
}

function ShoppingBag(props) {
  return (
    <div className='col-auto pr-0 shopping-bag-count-container'>
      <Link
        onClick={preventDoubleClick}
        className='d-flex align-items-center shoppingBagLink'
        to='/webapp/wcs/stores/servlet/OrderItemDisplay?storeId=301&catalogId=301&langId=-1'
        rel='nofollow'
      >
        <ShoppingBagIcon />
        <span className='cartItemCount'>({props.myDillardsInfo.miniCartInfo.cartItemCount})</span>
        <span className='sr-only'> items in cart</span>
      </Link>
    </div>
  );
}

function MenuItem({ text, to, className = '', ...props }) {
  return (
    <li className={`hide-when-international ${className}`}>
      <Link to={to} rel='nofollow' {...props}>
        {text}
      </Link>
    </li>
  );
}

function LoginDropdown(props) {
  const [arrowClicked, setArrowClicked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const showAccountDD = arrowClicked || isHovered;

  const toggleAccountDD = () => {
    if (arrowClicked) setIsHovered(false);
    setArrowClicked((prev) => !prev);
  };
  const showAccountDDHandler = () => setIsHovered(true);
  const hideAccountDDHandler = () => setIsHovered(false);

  const userLoggedInStatus = props.myDillardsInfo.userInformation.userLoggedInStatus || 'guest';
  const persistent = props.myDillardsInfo.userInformation.persistent === 'persistent';
  const defaultRegistry = props.myDillardsInfo.userInformation.DefaultRegistry;

  return (
    <div
      className='hide-when-international myAccountDD col-auto'
      onMouseOver={showAccountDDHandler}
      onMouseOut={hideAccountDDHandler}
    >
      <UserLoginIcon />
      <Link
        to={
          persistent || userLoggedInStatus === 'persistent'
            ? `/webapp/wcs/stores/servlet/RememberMeLogonFormView?URL=${location.pathname}`
            : '/webapp/wcs/stores/servlet/LogonForm?storeId=301&langId=-1&catalogId=301'
        }
        rel='nofollow'
        aria-label='login'
        aria-describedby='login menu'
        className='mx-1 myAccountDDLink'
      >
        {userLoggedInStatus === 'registered' ? 'My Account' : 'Login'}
      </Link>
      <button
        onClick={toggleAccountDD}
        className='btn-tertiary'
        type='button'
        aria-label='Login'
        aria-controls='accountDDContainer'
        aria-expanded={showAccountDD ? 'true' : 'false'}
      >
        <ArrowDownIcon />
      </button>
      <div id='accountDDContainer' className={`accountDDContainer ${showAccountDD ? 'accountDDShowContainer' : ''}`}>
        <div className='accountDD'>
          <ul>
            {userLoggedInStatus === 'guest' ? (
              <li className='hide-when-international login'>
                <Link
                  to='/webapp/wcs/stores/servlet/LogonForm?storeId=301&langId=-1&catalogId=301'
                  rel='nofollow'
                  className='btn btn-primary'
                >
                  Login
                </Link>
              </li>
            ) : null}
            {persistent && (
              <li className='hide-when-international login'>
                <Link
                  to={`/webapp/wcs/stores/servlet/RememberMeLogonFormView?URL=${location.pathname}`}
                  rel='nofollow'
                  className='btn btn-primary'
                >
                  Login
                </Link>
              </li>
            )}
            <MenuItem
              text="My Dillard's Account"
              to='/webapp/wcs/stores/servlet/LogonForm?storeId=301&langId=-1&catalogId=301'
            />
            <MenuItem text='Just For You' to='/c/just-for-you' />
            <MenuItem
              text='Order History'
              to='/webapp/wcs/stores/servlet/OrderStatusLoginChk?storeId=301&catalogId=301&langId=-1&orderStatus=true'
            />
            <MenuItem text='Returns' to='/c/returns' />
            <li className='hide-when-international payMyBillBtn'>
              <button
                className='btn-tertiary payMyBillBtn'
                data-toggle='modal'
                data-target='.citi-speedbump'
                data-modal-title=' '
                data-modal-body='citibankSpeedbump({"citiLink": "https://citiretailservices.citibankonline.com/RSauth/signon?pageName=signon&siteId=PLCN_DILLARDS&langId=en_US"})'
              >
                Pay My Bill
              </button>
            </li>
            <MenuItem
              text='My Wish List'
              to={
                persistent
                  ? '/webapp/wcs/stores/servlet/LogonForm?storeId=301&catalogId=301&langId=-1&rURL=InterestItemDisplay'
                  : '/webapp/wcs/stores/servlet/InterestItemDisplay?storeId=301&catalogId=301&langId=-1'
              }
            />
            <MenuItem text='Find a Store' to='/stores' />
            {defaultRegistry ? (
              <MenuItem
                text='My Registry'
                to={`/webapp/wcs/stores/servlet/RegistryManageProducts?catalogId=301&langId=-1&storeId=301&actionCode=M&registryNumber=${defaultRegistry}`}
              />
            ) : null}
            {userLoggedInStatus === 'registered' ? (
              <li className='hide-when-international logout p-0'>
                <Link
                  to={`/webapp/wcs/stores/servlet/Logoff?URL=/`}
                  rel='nofollow'
                  className='btn btn-primary'
                  onClick={() => savePersonalizationPointsToDatabase(props.passedAppFunctions.wasParms, false)}
                >
                  Logout
                </Link>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default HeaderContainer;
export { LoginDropdown, ShoppingBag };
